import type { FaireProductEntity } from "../../entity_types/product";

export const p_4qpolmb6l7: FaireProductEntity = {
  token: "p_4qpolmb6l7",
  type: "product",
  name: "Copper Healing Sphere",
  brandToken: "b_92q2hhsl",
  brandName: "Tiny Rituals",
  imageUrl:
    "https://cdn.faire.com/fastly/8c71852c4485f6082e8f7773a1e2d708208a16462f40c630da2b36005ed4a987.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2b93d0c022f7bc1edfa2f34c47dbaec9c8ddd9a1845c6a71b8e09b4b64a74a31.jpeg",
  ],
  priceDollars: 48,
  description:
    "Invite more alchemy into your life with this radiant Small Copper Sphere designed for delectable healing. Copper is one of the worlds most magical metals. Known for its ability for channeling energy and serving as a conduit between heaven and earth, this tiny Copper Sphere is here to level up your life and bring a burst of vitality back to the page.\n\n“With this sphere, I welcome positive healing energy from all directions”\n\nDETAILS\nPure Copper Sphere\nApprox. diameter 1.125, and weight 4.2 oz\nMarkings may vary\nComes with a description card",
  tags: [],
  msrpDollars: 96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:31.908Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
